<!-- Ultra-Minimal CATIA-style Metin Notu Dialog -->
<div class="metin-notu-dialog">

  <!-- Üst Toolbar - Nokta Seçimi -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <div class="ayar-satir">
        <button class="catia-btn" [class.active]="nokta" (click)="noktaSec()"
                style="flex: 1; background: linear-gradient(135deg, rgba(255, 215, 0, 0.15), rgba(255, 215, 0, 0.25)); border-color: rgba(255, 215, 0, 0.4); color: #FFD700;">
          <i class="crosshairs icon"></i>
          {{nokta ? 'Konum Seçildi ✓' : 'Konum Seç'}}
        </button>
      </div>
    </div>
  </div>

  <!-- Metin Girişi -->
  <div class="catia-toolbar">
    <div class="toolbar-grup">
      <!-- Metin girişi - Icon + Input -->
      <div class="input-icon-grup">
        <i class="font icon"></i>
        <textarea
          [(ngModel)]="notMetni"
          (ngModelChange)="metniGuncelle()"
          rows="2"
          placeholder="Not metni..."
          class="catia-textarea"></textarea>
      </div>
    </div>
  </div>

  <!-- Kontrol Paneli - Sekmeli Ultra Kompakt -->
  <div class="kontrol-paneli">

    <!-- Sekme 1: Görünüm -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="sekmeler.gorunum = !sekmeler.gorunum">
        <i class="eye icon"></i>
        <span>Görünüm</span>
        <i class="chevron" [class.down]="sekmeler.gorunum" [class.right]="!sekmeler.gorunum"></i>
      </div>
      <div class="sekme-icerik" *ngIf="sekmeler.gorunum">

        <!-- Renk Palette - Kompakt Grid -->
        <div class="ayar-satir">
          <label>Metin</label>
          <div class="renk-palette">
            <div
              *ngFor="let r of renkler; let i = index"
              class="renk-kutu"
              [style.background-color]="r.kod"
              [class.secili]="renk === r.kod"
              (click)="renkDegistir(r.kod)"
              [title]="r.isim"></div>
            <input type="color" [(ngModel)]="renk" (ngModelChange)="renkDegistir($event)" class="renk-picker-mini">
          </div>
        </div>

        <!-- Arka Plan Rengi -->
        <div class="ayar-satir">
          <label>Arka Plan</label>
          <div class="renk-kontrol">
            <input type="color" [(ngModel)]="arkaplanRengi" (ngModelChange)="arkaplanDegistir()" class="renk-input">
            <input type="range" [(ngModel)]="arkaplanOpaklik" (ngModelChange)="arkaplanDegistir()" min="0" max="100" class="opacity-slider">
            <span class="deger-gosterge">{{arkaplanOpaklik}}%</span>
          </div>
        </div>

        <!-- Çerçeve Rengi -->
        <div class="ayar-satir">
          <label>Çerçeve</label>
          <div class="renk-kontrol">
            <input type="color" [(ngModel)]="cercevRengi" (ngModelChange)="cerceveDegistir()" class="renk-input">
            <input type="range" [(ngModel)]="cercevKalinlik" (ngModelChange)="cerceveDegistir()" min="0" max="5" step="0.5" class="kalinlik-slider">
            <span class="deger-gosterge">{{cercevKalinlik}}px</span>
          </div>
        </div>

        <!-- Font Boyutu -->
        <div class="ayar-satir">
          <label>Boyut</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="boyut" (ngModelChange)="boyutDegistir()" min="8" max="128" step="2" class="boyut-slider">
            <span class="deger-gosterge">{{boyut}}px</span>
          </div>
        </div>

        <!-- Sabit Boyut -->
        <div class="ayar-satir">
          <label>Sabit Boyut</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="sabitBoyut" (ngModelChange)="sabitBoyutDegistir()" id="sabitBoyutGorunum" class="catia-checkbox">
            <label for="sabitBoyutGorunum" class="checkbox-label">Zoom'dan Bağımsız</label>
          </div>
        </div>

      </div>
    </div>

    <!-- Sekme 2: Stil -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="sekmeler.stil = !sekmeler.stil">
        <i class="paint brush icon"></i>
        <span>Stil</span>
        <i class="chevron" [class.down]="sekmeler.stil" [class.right]="!sekmeler.stil"></i>
      </div>
      <div class="sekme-icerik" *ngIf="sekmeler.stil">

        <!-- Font Ailesi -->
        <div class="ayar-satir">
          <label>Font</label>
          <select [(ngModel)]="fontAilesi" (ngModelChange)="stilDegistir()" class="catia-select">
            <option value="Arial">Arial</option>
            <option value="Courier New">Courier New</option>
            <option value="Times New Roman">Times New Roman</option>
            <option value="Verdana">Verdana</option>
            <option value="Consolas">Consolas</option>
          </select>
        </div>

        <!-- Font Stili -->
        <div class="ayar-satir">
          <label>Stil</label>
          <div class="button-grup">
            <button class="mini-btn" [class.active]="fontKalin" (click)="fontKalin = !fontKalin; stilDegistir()">
              <i class="bold icon"></i>
            </button>
            <button class="mini-btn" [class.active]="fontItalik" (click)="fontItalik = !fontItalik; stilDegistir()">
              <i class="italic icon"></i>
            </button>
          </div>
        </div>

        <!-- Hizalama -->
        <div class="ayar-satir">
          <label>Hiza</label>
          <div class="button-grup">
            <button class="mini-btn" [class.active]="hizalama === 'left'" (click)="hizalama = 'left'; stilDegistir()">
              <i class="align left icon"></i>
            </button>
            <button class="mini-btn" [class.active]="hizalama === 'center'" (click)="hizalama = 'center'; stilDegistir()">
              <i class="align center icon"></i>
            </button>
            <button class="mini-btn" [class.active]="hizalama === 'right'" (click)="hizalama = 'right'; stilDegistir()">
              <i class="align right icon"></i>
            </button>
          </div>
        </div>

        <!-- Padding -->
        <div class="ayar-satir">
          <label>İç Boşluk</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="padding" (ngModelChange)="stilDegistir()" min="4" max="32" step="2" class="padding-slider">
            <span class="deger-gosterge">{{padding}}px</span>
          </div>
        </div>

      </div>
    </div>

    <!-- Sekme 3: Çizim -->
    <div class="ayar-sekme">
      <div class="sekme-baslik" (click)="sekmeler.cizim = !sekmeler.cizim">
        <i class="pencil alternate icon"></i>
        <span>Çizim</span>
        <i class="chevron" [class.down]="sekmeler.cizim" [class.right]="!sekmeler.cizim"></i>
      </div>
      <div class="sekme-icerik" *ngIf="sekmeler.cizim">

        <!-- Ok İşaretçi -->
        <div class="ayar-satir">
          <label>Ok Çizgisi</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="okGoster" (ngModelChange)="okDurumDegistir()" id="okGoster" class="catia-checkbox">
            <label for="okGoster" class="checkbox-label">Göster</label>
          </div>
        </div>

        <!-- Ok Rengi (sadece ok aktifse) -->
        <div class="ayar-satir" *ngIf="okGoster">
          <label>Ok Rengi</label>
          <div class="renk-kontrol">
            <input type="color" [(ngModel)]="okRengi" (ngModelChange)="okStilDegistir()" class="renk-input">
            <input type="range" [(ngModel)]="okKalinlik" (ngModelChange)="okStilDegistir()" min="1" max="5" step="0.5" class="kalinlik-slider">
            <span class="deger-gosterge">{{okKalinlik}}px</span>
          </div>
        </div>

        <!-- Ok Tipi -->
        <div class="ayar-satir" *ngIf="okGoster">
          <label>Ok Tipi</label>
          <select [(ngModel)]="okTipi" (ngModelChange)="okStilDegistir()" class="catia-select">
            <option value="solid">Düz</option>
            <option value="dashed">Kesik</option>
            <option value="dotted">Noktalı</option>
          </select>
        </div>

        <!-- Gölge -->
        <div class="ayar-satir">
          <label>Gölge</label>
          <div class="checkbox-kontrol">
            <input type="checkbox" [(ngModel)]="golgeGoster" (ngModelChange)="golgeDegistir()" id="golgeGoster" class="catia-checkbox">
            <label for="golgeGoster" class="checkbox-label">Aktif</label>
          </div>
        </div>

        <!-- Gölge Mesafe -->
        <div class="ayar-satir" *ngIf="golgeGoster">
          <label>Gölge Mesafe</label>
          <div class="slider-kontrol">
            <input type="range" [(ngModel)]="golgeMesafe" (ngModelChange)="golgeDegistir()" min="0" max="20" step="1" class="shadow-slider">
            <span class="deger-gosterge">{{golgeMesafe}}px</span>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- Alt Aksiyon Bar - CATIA Style -->
  <div class="aksiyon-bar">
    <button class="catia-btn ekle-btn" (click)="notEkle()" [disabled]="!nokta">
      <i class="plus icon"></i>
      Ekle
    </button>
    <button class="catia-btn guncelle-btn" (click)="notGuncelle()" [disabled]="!aktifNot">
      <i class="sync icon"></i>
      Güncelle
    </button>
    <button class="catia-btn sil-btn" (click)="notSil()" [disabled]="!aktifNot">
      <i class="trash icon"></i>
      Sil
    </button>
    <div style="flex: 1;"></div>
    <button class="catia-btn kapat-btn" (click)="kapat()">
      <i class="close icon"></i>
      Kapat
    </button>
  </div>

</div>
